import React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

export const BreadcrumbComponent = ({ breadcrumbData }) => {
  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
      {breadcrumbData?.map((item, index) => {
        return item?.route ? (
          <Typography
            component={Link}
            to={item.route}
            state={item.state}
            sx={{ textDecoration: 'none' }}
            variant="bannerDescription"
            color="primary"
            key={index}>
            {item.label}
          </Typography>
        ) : (
          <Typography variant="bannerDescription" key={index}>
            {item.label}
          </Typography>
        );
      })}
    </Breadcrumbs>
  );
};

BreadcrumbComponent.propTypes = {
  breadcrumbData: PropTypes.array,
};
